module.exports = __webpack_public_path__ + "img/1737565940364 copia.17eab5d2.jpg";